import React from "react";
import { Col, Row } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";
import ChoiceInput from "../../choiceInput";
import ReactTooltip from "react-tooltip";

interface Props {
  isEmbeddedPost: boolean;
  updateIsEmbeddedPost: () => void;
  offSet: number;
}

class IsEmbeddedSection extends React.PureComponent<Props> {
  static defaultProps = {
    isEmbeddedPost: false,
    offSet: 0,
  };

  render() {
    const isEmbeddedPost = this.props.isEmbeddedPost;
    return (
      <Col
        className={s.content}
        md={{ size: !isEmbeddedPost ? 12 : 12, offset: this.props.offSet }}
        sm={12}
      >
        <Row>
          <ChoiceInput
            title={"Post to Website "}
            checked={this.props.isEmbeddedPost}
            onChangeHandler={this.props.updateIsEmbeddedPost}
            id={
              "isEmbeddedPost" +
              (this.props.isEmbeddedPost ? "_checked" : "_unchecked")
            }
            showInfo={true}
            infoId={"PostWebOption"}
          />
          <ReactTooltip
            id={`tpPostWebOption`}
            type="info"
            place="top"
            effect="float"
          >
            Select to create content for the ViewSpark embedded page.
          </ReactTooltip>
        </Row>
      </Col>
    );
  }
}

export default withStyles(s)(IsEmbeddedSection);
